// Feature flags. Leave Management is hidden for the current prod deploy —
// flip to true to restore its nav menu item and the /management/leave route.
export const LEAVE_MANAGEMENT_ENABLED = true;

// Colors
export const COLORS = {
  PRIMARY: '#0D213B',
  SECONDARY: '#F1AC2F',
  SUCCESS: '#10b981',
  ERROR: '#ef4444',
  WARNING: '#f59e0b',
  WHITE: '#ffffff',
  LIGHT_GREY: '#f8fafc',
  GREY: '#6b7280',
  LIGHT_WHITE: 'rgba(255,255,255,0.7)',
  DARK_WHITE: 'rgba(255,255,255,0.2)',
  DRAFT_GREEN: '#166534',
};

// Shared MUI sx for expense table header cells (used in ExpenseRequestForm + MyExpenseRequestsPage)
export const EXPENSE_TABLE_TH_SX = {
  backgroundColor: '#EBF5FB',
  fontWeight: 600,
  fontSize: '0.8rem',
  color: '#374151',
  py: 1.5,
  borderBottom: '1px solid #DBEAFE',
  whiteSpace: 'nowrap',
};
// Local Storage Keys
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  THEME: 'theme',
  LANGUAGE: 'language',
};
// Export announcement styles
export * from './announcementStyles'; 